import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { BasketTotalsService } from 'src/app/services/basket-totals.service';
import { BasketService } from 'src/app/services/basket.service';
import { TrybeService } from 'src/app/services/trybe.service';
import { Store } from 'src/app/store';

@Component({
    selector: 'app-trb-basket',
    templateUrl: './trb-basket.component.html',
    styleUrls: ['./trb-basket.component.css']
})
export class TrbBasketComponent implements OnInit {
    @Input() basketItem;
    @Input() basketItemIdx;
    @Input() allowDelete = true;
    @Input() latestChangeTime = new Date().getTime()

    spaBasket;

    constructor(
        private tryBeService: TrybeService,
        private basketTotalsService: BasketTotalsService,
        private basketService: BasketService,
        private store: Store,
    ) { }

    ngOnInit(): void {
        if (this.basketItem) {
            this.getSpaBasket()
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.latestChangeTime && !changes.latestChangeTime.firstChange) {
            this.getSpaBasket()
        }
    }

    getSpaBasket() {
        this.spaBasket = this.basketItem.spa.trybeBasket;
        // this.tryBeService.basketGet(this.basketItem.spa.trybeBasket.id).subscribe(data => {
        //     this.spaBasket = data.data.data;
        // })
    }

    removeItem(item) {
        let basket = this.store.selectForLocal('basket');

        this.tryBeService.basketRemoveItem(this.spaBasket.id, item.id).subscribe(data => {
            this.spaBasket = data.data.data;
            this.basketItem.spa.trybeBasket = data.data.data;
            basket.items[this.basketItemIdx].spa.trybeBasket = data.data.data;

            basket.items[this.basketItemIdx].checkoutTotals = this.basketTotalsService.calculateItemTotals(basket, basket.items[this.basketItemIdx], basket.user)
            basket = this.basketTotalsService.totalBasket(basket);

            this.basketService.saveBasket(basket);

            // this.gaService.removeSpaProduct(item)
        })
    }
}
